document.addEventListener('DOMContentLoaded', function () {
  var MINIMUM_TOTAL_CENTS = 1499; // $14.99

  function formatMoneyFromCents(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function showMinOrderWarning(currentTotalCents) {
    var minimumText = formatMoneyFromCents(MINIMUM_TOTAL_CENTS);
    var currentTotalText = formatMoneyFromCents(currentTotalCents);

    // Show an alert when not on the cart page (covers popup/drawer)
    if (window.location.pathname !== '/cart') {
      alert(
        'Minimum order amount is ' + minimumText +
        '. Your current total is ' + currentTotalText +
        '. Please add more items to continue to checkout.'
      );
    }

    // Also inject a visible message on the cart page
    var messageContainer = document.querySelector('.cart-minimum-warning-js');

    if (!messageContainer) {
      var subtotal = document.querySelector('.cart-subtotal');
      if (subtotal && subtotal.parentNode) {
        messageContainer = document.createElement('p');
        messageContainer.className = 'cart-minimum-warning-js cart-minimum-warning';
        subtotal.parentNode.insertBefore(messageContainer, subtotal.nextSibling);
      } else {
        var form =
          document.querySelector('form[action="/cart"]') ||
          document.querySelector('form[aria-label="cart checkout"]') ||
          document.querySelector('form');

        if (!form) {
          return;
        }

        messageContainer = document.createElement('p');
        messageContainer.className = 'cart-minimum-warning-js cart-minimum-warning';
        form.appendChild(messageContainer);
      }
    }

    messageContainer.textContent =
      'Minimum order amount is ' + minimumText +
      '. Your current total is ' + currentTotalText +
      '. Please add more items before proceeding to checkout.';

    if (window.location.pathname === '/cart') {
      messageContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function proceedToCheckout() {
    // Always go straight to checkout; Shopify will use current cart.
    window.location.href = '/checkout';
  }

  function handleCheckoutClick(event, clickedElement) {
    event.preventDefault();

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart || typeof cart.total_price !== 'number') {
          // Fail open on unexpected data
          proceedToCheckout();
          return;
        }

        if (cart.total_price < MINIMUM_TOTAL_CENTS) {
          showMinOrderWarning(cart.total_price);
        } else {
          proceedToCheckout();
        }
      })
      .catch(function () {
        // Fail open on network error
        proceedToCheckout();
      });
  }

  // Global delegated click handler
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;

      var checkoutTrigger = target.closest(
        'button[name="checkout"], ' +
        'button[data-checkout], ' +
        'a[href="/checkout"], ' +
        'a[href^="/checkout"]'
      );

      if (!checkoutTrigger) {
        return;
      }

      // Ignore middle-click / modifier key combinations
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      handleCheckoutClick(event, checkoutTrigger);
    },
    true // capture phase
  );
});
